import { z } from 'zod/v4'

export const flowerSubscriptionSettingsFormSchema = z.object({
  expected_policy_version: z.number().int().positive(),
  policy_html: z.string().trim().min(1, 'Enter your shop’s subscription policies.'),
  policy_text: z.string(),
})

export const flowerSubscriptionPlatformSettingsFormSchema = z.object({
  expected_platform_version: z.number().int().positive(),
  platform_html: z
    .string()
    .trim()
    .min(1, 'Enter the standard billing and renewal terms customers must accept.'),
  platform_text: z.string(),
})
